module.exports = __webpack_public_path__ + "static/media/check@3x.638cd04e.png";